// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2VVC8","error":"Textarea_error__ayxmz","readonly":"Textarea_readonly__3_btu","disabled":"Textarea_disabled__2eXpV"};